// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--SsdZC","icon":"icon--SsdZC","right":"right--SsdZC","heading":"heading--SsdZC","body":"body--SsdZC"};